// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"252":"a1f99a64","790":"9569f2ce","829":"9569f2ce"}[chunkId] + ".css";
};